export default __webpack_public_path__ + "static/media/header_bg.b4ff6da1.png";